/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type SlideStatusChange = {
    /**
     * new status
     */
    new_status: SlideStatusChange.new_status;
    /**
     * old status
     */
    old_status?: SlideStatusChange.old_status | null;
    readonly created_at?: string;
    /**
     * user that caused status change
     */
    user?: number | null;
}

export namespace SlideStatusChange {

    /**
     * new status
     */
    export enum new_status {
        RECEIVED_WPL = 'received-wpl',
        RECEIVED_LAB = 'received-lab',
        PENDING = 'pending',
        PRECOMPUTING = 'precomputing',
        UPLOADED = 'uploaded',
        ERROR = 'error',
        MANUAL_MERGE = 'manual-merge',
        MANUAL_REVIEW = 'manual-review',
        SUCCESS = 'success',
        PENDING_AI = 'pending-ai',
        DELETED = 'deleted',
        ARCHIVED = 'archived',
        ON_HOLD = 'on-hold',
    }

    /**
     * old status
     */
    export enum old_status {
        RECEIVED_WPL = 'received-wpl',
        RECEIVED_LAB = 'received-lab',
        PENDING = 'pending',
        PRECOMPUTING = 'precomputing',
        UPLOADED = 'uploaded',
        ERROR = 'error',
        MANUAL_MERGE = 'manual-merge',
        MANUAL_REVIEW = 'manual-review',
        SUCCESS = 'success',
        PENDING_AI = 'pending-ai',
        DELETED = 'deleted',
        ARCHIVED = 'archived',
        ON_HOLD = 'on-hold',
    }


}
